import script from "./ho-radio.vue?vue&type=script&lang=ts&setup=true"
export * from "./ho-radio.vue?vue&type=script&lang=ts&setup=true"

import "./ho-radio.vue?vue&type=style&index=0&id=79b2edf6&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b2edf6"]])

export default __exports__